import {
  Component, OnInit, AfterViewInit, Inject, ElementRef, ViewChild, NgZone,
  HostListener, OnDestroy
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import {
  sampleProducts, sampleLots, sampleMains, BuilderInfo, Product, BCASearch,
  GasRequestStatusEnum,
  Gasbca
} from '@app/base/core/models';
import { BuilderService } from '@app/modules/builder/base';
import { ConstantsService, SessionService, AccountService, LookupsService } from '@app/base/core';
import { triggerFormValidation, focusFirstInvalidField } from '@app/base/shared';
import { SocoHttpService } from '@app/soco/http';
import { AutocompleteComponent } from '@app/base/shared/controls';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { takeWhile, take } from 'rxjs/operators';
import { AlertService } from '@app/base/alerts/alert.service';
import { LandingService } from '@app/modules/landing';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
declare var swal: any;
require('sweetalert');

interface SubName {
  id: number;
  itemName: string;
}

interface ProjectDetails {
  stateCd: string;
  projectNumber: number;
  projectName: string;
  grStatus: string;
  bgrStatus: string;
  requestTypeCd: string;
  isServiceRequested: string;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(AutocompleteComponent, { static: false }) comp: AutocompleteComponent;
  @ViewChild('endDate', { static: false }) endDate;
  @ViewChild('startDate', { static: false }) startDate;
  @ViewChild(GridComponent, { static: false })
  public grid: GridComponent;
  @ViewChild('firstColumn', { static: false }) firstColumn;
  @ViewChild('secondColumn', { static: false }) secondColumn;
  @ViewChild('thirdColumn', { static: false }) thirdColumn;
  @ViewChild('fourthColumn', { static: false }) fourthColumn;
  @ViewChild('fifthColumn', { static: false }) fifthColumn;
  @ViewChild('seventhColumn', { static: false }) seventhColumn;
  @ViewChild('eighthColumn', { static: false }) eighthColumn;
  @ViewChild('ninthColumn', { static: false }) ninthColumn;
  @ViewChild('tenthColumn', { static: false }) tenthColumn;
  @ViewChild('elevnthColumn', { static: false }) elevnthColumn;
  @ViewChild('twelfthColumn', { static: false }) twelfthColumn;

  public errorMessage;

  public searchElementRef: ElementRef;

  @HostListener('click', ['$event'])
  onClick(event) {

  }
  data: any;
  dataItem: any;
  public modelGasBca: Gasbca;
  public rowId: any;
  public admin: boolean;
  public infoWindowOpen: boolean;
  public searchControl: FormControl;
  public bcaData: any = [];
  public builderInfo: BuilderInfo = {
    Admin: false,
    BuilderId: [],
    subsidiaryId: [],
    CompanyName: '',
    IsActive: '',
    subsidiaryList: [],
    CompanyAddress: {
      id: '',
      contactTypeCode: '',
      streetNumber: '',
      recUpdatedDate: '',
      recCreatedDate: '',
      recCreatedBy: '',
      recUpdatedBy: '',
      streetName: '',
      directionPrefix: '',
      directionSuffix: '',
      streetType: '',
      city: '',
      state: '',
      zipCode: '',
      contactName2Extn: '',
      contactName1Phone: '',
      contactName1AreaCode: '',
      contactName2AreaCode: '',
      contactName2Phone: '',
      address2: '',
      unitNumber: ''
    },
    CompanyEmail: '',
    //  AdminUsers: [{ firstName: '', lastName: '', userId: '', builderId: '', email: '' }],
    BuilderMapping: [{ id: '', builderName: '', subsidiaryId: [], subsidiaryName: [], status: '' }]
  };
  public bcaItem = [];
  public result: ExcelExportData;
  public dropDown: string;
  public bcaStatuses = [];
  accordionSign = true;
  accordion = true;
  emailId: string;
  userName: string;
  GridId: number;
  stateCd: string;
  subsidaryList = [];
  subList: SubName[];
  editing = false;

  alertMsg: any = [];
  public state: State = {
    skip: 0,
    take: 10,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public killsubscribe: boolean;
  public searchAddress: string = null;
  public filter = '';
  public requestTypeCd: string;
  public flag = 0;
  public isServiceRequested;
  public error: any = { isError: false, errorMessage: '', stDateError: false };
  public strterror: any = { isError: false, errorMessage: '' };
  public subsidiaryList: any = [];
  public myaddress: FormControl = new FormControl('');
  public gridData: GridDataResult = process(sampleProducts, this.state);
  public bcaGridData: GridDataResult = process(this.bcaData, this.state);
  public gridMains: GridDataResult = process(sampleMains, this.state);
  // Code to define form to bind thhe search inputs
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: null,
    projectAddress: null,
    bcaStatus: null,
    subsidaryId: null,
    subsidarycompanyName: null,
    startDate: null,
    endDate: null,
    bcaStatusValue: null
  };
  public gasrequest = [];
  public show = false;
  public developmentStat: string;
  public GasRequestStatus = GasRequestStatusEnum;
  public pageSizes = true;
  public previousNext = true;
  public buttonCount = 5;
  public mindate: string;
  public maxDate: string;
  public info = true;
  public updateSuccess: boolean;
  public type: 'numeric' | 'input' = 'numeric';
  public projectNumber: number;
  public projectName: string;
  public grStatus: string;
  public bgrStatus: string;
  public grTypeCd: string;
  public developmentStatus: any;
  public bcaValue: string;
  public requestSearchForm: FormGroup;
  public searchForm: FormGroup;

  projectList: any[] = [];
  activeProjectLength: number;
  filterProjectLength: number;
  activeProjects: any[] = [];
  filterProjectInside: any[] = [];
  filterProjects: any[] = [];
  showOnlyActive: boolean;

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(sampleProducts, this.state);
    this.bcaGridData = process(this.bcaData, this.state);
    this.gridMains = process(sampleMains, this.state);
    this.fitColumns();
  }

  constructor(
    @Inject(Router) private router: Router,
    @Inject(NgZone) private ngZone: NgZone,
    private http: BuilderService,
    private el: ElementRef,
    private landingSvc: LandingService,
    public session: SessionService,
    public constantsSvc: ConstantsService,
    public accountSvc: AccountService,
    public socoHttp: SocoHttpService,
    public lookupSvc: LookupsService,
    public fb: FormBuilder,
    public constSvc: ConstantsService, private alertService: AlertService, private datePipe: DatePipe,
  ) {
    this.allData = this.allData.bind(this);
  }
  ngOnInit() {

    this.killsubscribe = true;
    this.userName = this.accountSvc.account.user.username;
    this.emailId = this.accountSvc.account.user.email;
    this.showOnlyActive = true;

    // create search form
    this.requestSearchForm = new FormGroup({
      requestId: new FormControl(null,
        [Validators.pattern(this.constSvc.numericPattern)]),
      projectName: new FormControl(null),
      projectAddress: new FormControl(null),
      subsidaryCompany: new FormControl(null),
      startDate: new FormControl('', [Validators.pattern(this.constSvc.datePattern)]),
      endDate: new FormControl('', [Validators.pattern(this.constSvc.datePattern)]),
      bcaStatus: new FormControl(null)
    }, { updateOn: 'blur' });

    //create project search Form
    this.searchForm = new FormGroup({
      builderId: new FormControl(''),
      projectNo: new FormControl(''),
      projectAddress: new FormControl('')
    });

    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Builder Home'));
        this.developmentStatus = this.lookupSvc.developmentStatus.lookupValues;
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.initialLoad();
    this.getHolidayList();

    //calling API
    //const projectDataStorage = localStorage.getItem('projectData');
    //if (projectDataStorage) {
    //  this.projectList = JSON.parse(projectDataStorage);
    //  this.activeProjects = this.projectList.filter(d => d.bgrStatus == "ACTPRJ")
    //  this.activeProjectLength = this.activeProjects.length;
    //}
  }

  // code to populate previously loaded grid data from service if user is visiting home screen again
  public initialLoad() {
    this.session.BcaData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
      if (success !== null) {
        this.bcaData = success;
        this.session.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
          if (success) {
            for (let i = 0; i < success.BuilderId.length; i++) {
              this.builderInfo.BuilderId[i] = success.BuilderId[i];
            }
            this.admin = success.Admin;
            if ((success.subsidiaryList !== null) && (success.subsidiaryList !== undefined)) {
              // tslint:disable-next-line
              this.subList = success.subsidiaryList.sort((a, b) => {
                if (a.itemName > b.itemName) {
                  return 1;
                }
                if (a.itemName < b.itemName) {
                  return -1;
                }
              });
            }
            this.builderInfo.BuilderMapping = success.BuilderMapping;
          }
        });
        this.session.searchFilter.pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          this.bcaSearch = result;
          this.fillSeachform();
        });

        this.session.SearchInside$.pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          this.searchForm.patchValue({
            builderId: result.builderId,
            projectNo: result.projectNo,
            projectAddress: result.projectAddress
          });
        })

        this.session.ShowActiveProjectData$.pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          this.showOnlyActive = result;
        })

        // check
        this.session.ProjectList$.pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          this.projectList = result;
        });

        this.session.ProjectData$.pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          if (this.showOnlyActive) {
            this.activeProjects = result.filter(d => d.bgrStatus == "ACTPRJ");
            this.activeProjectLength = this.activeProjects.length;
          } else {
            this.filterProjects = result;
            this.filterProjectInside = result;
            this.filterProjectLength = this.filterProjects.length;
          }
        });

        this.resetInternalSearchForm();

        this.bcaGridData = process(this.bcaData, this.state);
        if ((this.lookupSvc.gasRequestStatus.lookupValues !== null) && (this.lookupSvc.gasRequestStatus.lookupValues !== undefined)) {
          // tslint:disable-next-line
          this.bcaStatuses = this.lookupSvc.gasRequestStatus.lookupValues.sort((a, b) => {
            if (a.itemName > b.itemName) {
              return 1;
            }
            if (a.itemName < b.itemName) {
              return -1;
            }
          });
          this.searchForm!.valueChanges.pipe(takeWhile(() => this.killsubscribe)).subscribe(values => {
            this.filterProjectsInternally(values);
          });
        }
      } else {
        // this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
        this.lookupSvc.commonLookupsLoaded$.subscribe(
          loadingStatus => {
            if (loadingStatus) {
              this.requestSearchForm.reset();
              this.requestSearchForm.clearValidators();
              this.loadItems();
            }
          }
        );
      }
    });


  }
  ngAfterViewInit(): void {
    const resizeUpdate = function () {
      if (window.innerWidth <= 1024) {
        $('.primary-selectors, .secondary-selectors').removeClass('ml-30');
      } else {
        $('.primary-selectors, .secondary-selectors').addClass('ml-30');
      }
    };
    window.addEventListener(
      'resize',
      function () {
        resizeUpdate();
      },
      true
    );
    resizeUpdate();
    this.fitColumns();

  }

  // code to fetch builder details from DB
  loadItems() {
    if (this.userName !== undefined) {
      this.session.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
        if (success) {
          for (let i = 0; i < success.BuilderId.length; i++) {
            this.builderInfo.BuilderId[i] = success.BuilderId[i];
          }
          this.admin = success.Admin;
          if ((success.subsidiaryList !== null) && (success.subsidiaryList !== undefined)) {
            // tslint:disable-next-line
            this.subList = success.subsidiaryList.sort((a, b) => {
              if (a.itemName > b.itemName) {
                return 1;
              }
              if (a.itemName < b.itemName) {
                return -1;
              }
            });
          }
          this.builderInfo.BuilderMapping = success.BuilderMapping;
          this.reset();
        } else {
          this.bcaGridData = process(this.bcaData, this.state);
          this.socoHttp.hidePleaseWait('ContainerAwaiter2');
        }
      });
    } else {
      this.bcaGridData = process(this.bcaData, this.state);
      this.socoHttp.hidePleaseWait('ContainerAwaiter2');
    }
  }
  // code to export grid data to excel
  public allData(): ExcelExportData {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.result = {
      data: process(this.bcaData, { filter: this.state.filter }).data
    };
    this.socoHttp.hidePleaseWait('ContainerAwaiter2');
    return this.result;
  }

  // used to unsubscribe to services
  ngOnDestroy() {
    this.killsubscribe = false;
    this.passBcaData();
    this.passSearchfilters();
    this.passProjectData();
  }

  // code to show 'no subsidiaries found' when subsidiary list is empty
  subsidaryDefault(e) {
    if (this.subList.length === 0) {
      setTimeout(() => {
        const mydiv = $('#subsidary').find('.ng-option');
        if (mydiv[0]) {
          mydiv[0].innerText = this.constantsSvc.noSubFound;

        }
      }, 0);

    }
  }

  // load search form based on previous search filters when user comes back to home screen
  fillSeachform() {
    this.requestSearchForm.patchValue({
      requestId: this.bcaSearch.reqId,
      projectName: this.bcaSearch.projectName,
      projectAddress: this.bcaSearch.projectAddress,
      subsidaryCompany: this.bcaSearch.subsidarycompanyName,
      startDate: this.bcaSearch.startDate,
      endDate: this.bcaSearch.endDate,
      bcaStatus: this.bcaSearch.bcaStatusValue
    });
    this.searchAddress = this.bcaSearch.projectAddress;
  }

  // code to populate grid at home screen from DB based on search filters applied
  bcaGrid() {
    // code to fetch bca data
    if ((this.lookupSvc.gasRequestStatus.lookupValues !== null) && (this.lookupSvc.gasRequestStatus.lookupValues !== undefined)) {
      // tslint:disable-next-line
      this.bcaStatuses = this.lookupSvc.gasRequestStatus.lookupValues.sort((a, b) => {
        if (a.itemName > b.itemName) {
          return 1;
        }
        if (a.itemName < b.itemName) {
          return -1;
        }
      });
    }

    if (this.bcaSearch.builderId.length !== 0 && this.showOnlyActive) {
      //calling API
      this.http.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
        // localStorage.setItem('projectData', JSON.stringify(result.data));
        this.projectList = result.data;
        this.activeProjects = this.projectList.filter(d => d.bgrStatus == "ACTPRJ")
        this.activeProjectLength = this.activeProjects.length;
      });

      this.searchForm!.valueChanges.subscribe(values => {
        this.filterProjectsInternally(values);
      });
    }

    /* Start --CXCO 751 :-28/05/2024 -Existing Service tracker removed --Srinivas
     if (this.bcaSearch.builderId.length !== 0) {
       this.http.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
         this.gasrequest = this.lookupSvc.gasRequestType;
         for (let val = 0; val < result.data.length; val++) {
           // code to show bcastatus name on grid

           if (result.data[val]['bgrStatus'] != null && this.bcaStatuses !== undefined) {
             const BrStatus = {
               oldbgrStatus: result.data[val]['bgrStatus']
             };
             result.data[val]['bgrStatus'] = (this.bcaStatuses.find(x => x.id === result.data[val]['bgrStatus'])).itemName;
             Object.assign(result.data[val], BrStatus);
           }

           // code to show gas request type on grid
           if (result.data[val]['gasRqstTpCd'] != null && this.gasrequest !== undefined) {
             const dummy = {
               oldReqTpCd: result.data[val]['gasRqstTpCd']
             };
             result.data[val]['gasRqstTpCd'] = (this.gasrequest.find(x => x.typeCode === result.data[val]['gasRqstTpCd'])).propertyType;
             Object.assign(result.data[val], dummy);

           }
           // code to show development status on grid
           if (result.data[val]['developmentStatus'] != null && this.developmentStatus !== undefined) {
             result.data[val]['developmentStatus'] =
               (this.developmentStatus.find(x => x.id === result.data[val]['developmentStatus'])).itemName;
           }
         }
         this.bcaData = result.data;
         this.state = {
           skip: 0,
           take: 10,
           // Initial filter descriptor
           filter: {
             logic: 'and',
             filters: []
           }
         };
         this.bcaGridData = process(this.bcaData, this.state);
         this.fitColumns();
         if (this.bcaGridData) {
           this.socoHttp.hidePleaseWait('ContainerAwaiter2');
         }
       },
         (error) => {
           this.socoHttp.hidePleaseWait('ContainerAwaiter2');
           swal(this.constantsSvc.errorSwal1, this.constantsSvc.projDetailsError, this.constantsSvc.errorSwal);
         });
     } else {
       swal(this.constantsSvc.errorSwal1, this.constantsSvc.projDetailsError, this.constantsSvc.errorSwal);
     }
     //End -Existing Service tracker removed --Srinivas*/
  }

  // export to excel and pdf disable
  //checkExport(): boolean {
  //  if (this.bcaData.length === 0) {
  //    return true;
  //  } else {
  //    return false;
  //  }
  //}

    // export to excel and pdf disable
    checkExport(): boolean {
        // Check if both activeProjects and filterProjects are empty
        if (this.activeProjects.length === 0 && this.filterProjects.length === 0) {
            return true;  // Disable export if both arrays are empty
        } else {
            return false; // Enable export if at least one array has data
        }
    }


  // code to update development status and show the updated data
  saveHandler(dataItem: any) {
    if (this.editing) {
      dataItem.developmentStatus = (this.dropDown.length !== 0) ? (this.dropDown) : (null);
    } else {
      dataItem.developmentStatus = (this.developmentStat.length !== 0) ? (this.developmentStat) : (null);
    }
    if (dataItem.developmentStatus !== null) {
      this.updateSuccess = true;
      this.show = false;
      dataItem.grStatus = dataItem.oldgrStatus;
      dataItem.bgrStatus = dataItem.oldbgrStatus;
      dataItem.gasRqstTpCd = dataItem.oldReqTpCd;
      this.modelGasBca = dataItem;
      this.modelGasBca.recUpdateUsrId = this.userName;
      this.modelGasBca.recUpdateDttm = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss');
      this.modelGasBca.developmentStatus = (this.developmentStatus.find(x => x.itemName === dataItem.developmentStatus)).id;
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
      this.http.editBCADetails(this.modelGasBca).subscribe(result => {
        if (result) {
          this.socoHttp.hidePleaseWait('ContainerAwaiter2');
          swal(this.constSvc.developmentStatusReqSwal, this.constSvc.developmentstatusSuccessSwal, this.constSvc.successSwal);
          this.bcaGrid();
        } else {
          this.socoHttp.hidePleaseWait('ContainerAwaiter2');
          this.show = false;

          swal(this.constSvc.developmentStatusReqSwal1, this.constSvc.developmentStatusFailSwal, this.constSvc.errorSwal);
        }
      },
        (error) => {
          this.socoHttp.hidePleaseWait('ContainerAwaiter2');
          this.show = false;
          swal(this.constSvc.developmentStatusReqSwal1, this.constSvc.developmentStatusFailSwal, this.constSvc.errorSwal);
        });
      this.editing = false;
      this.rowId = null;
    }
  }

  // Kendo BCA Grid
  toggleInfoWindow() {
    this.infoWindowOpen = !this.infoWindowOpen;
  }

  // code to resize BCA Grid based on data
  public fitColumns(): void {
    this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
    });
  }


  editCell(gridInstance, rowIndex, colIndex, dataItem) {

    this.updateSuccess = false;
    const status = dataItem.developmentStatus;
    this.developmentStat = status;
    gridInstance.editCell(rowIndex, colIndex, this.createFormGroup(dataItem));
  }

  editCellMobile(rowIndex, dataItem) {
    this.updateSuccess = false;
    const mobileEdit = dataItem.developmentStatus;
    this.dropDown = mobileEdit;
    this.rowId = rowIndex;
    this.editing = true;
  }

  closeCell() {
    this.editing = false;
    this.rowId = null;
  }

  cellCloseHandler(e) {
    if (this.updateSuccess === false) {
      e.dataItem.developmentStatus = (e.dataItem.developmentStatus !== null) ? (e.dataItem.developmentStatus) : (null);
    }


  }

  cancelHandler(sender, rowIndex, dataItem) {
    sender.closeRow(rowIndex);
    dataItem.developmentStatus = this.developmentStat;
    this.editing = false;
    this.rowId = null;
  }

  createFormGroup(dataItem: any): FormGroup {
    return this.fb.group({
      'bcaId': dataItem.bcaId,
      'bcaStatus': dataItem.bcaStatus,
      'builderId': dataItem.builderId,
      'createDate': dataItem.createDate,
      'developmentStatus': dataItem.developmentStatus,
      'enteredBy': dataItem.enteredBy,
      'finalPlat': dataItem.finalPlat,
      'grStatus': dataItem.grStatus,
      'bgrStatus': dataItem.bgrStatus,
      'id': dataItem.id,
      'mainInstallationStatus': dataItem.mainStatus,
      'gasRqstTpCd': dataItem.gasRqstTpCd,
      'projectName': dataItem.projectName,
      'serviceFormattedAddress': dataItem.serviceFormattedAddress,
      'stateCd': dataItem.stateCd,
    });
  }


  // Code to capture address selected from suggestion in Google auto-suggest text box
  getAddressFromAddressSuggestion(address) {
    this.searchAddress = address.formatted_address;
    this.bcaSearch.projectAddress = address.formatted_address;
  }

  // Code to capture address entered in Google auto-suggest text box
  getAddressFromTextBox(address) {
    this.searchAddress = address;
    this.bcaSearch.projectAddress = address;
  }

  // code to route to contract page on clicking of contract button
  routeToContract(grId) {
    this.session.sourceToContract = this.constantsSvc.BuilderUser;
    this.router.navigate([this.session.paramLdc.toLocaleLowerCase(), 'builder', 'contract', this.constantsSvc.BuilderUser, grId]);
  }

  // code to show subtabs on clicking of any cell in grid
  bcaDetails(projectDetails) {

    this.router.navigate([
      this.session.paramLdc.toLowerCase(),
      'builder',
      'request',
      projectDetails.id
    ]);
    this.stateCd = projectDetails.stateCd;
    this.projectNumber = projectDetails.bcaId;
    this.projectName = projectDetails.projectName;
    this.grStatus = projectDetails.oldgrStatus;
    this.bgrStatus = projectDetails.oldbgrStatus;
    this.grTypeCd = projectDetails.gasRqstTpCd;
    this.requestTypeCd = projectDetails.oldReqTpCd;
    this.isServiceRequested = projectDetails.isAllServiceRequested;
    this.passGrid();
  }

  // code to pass project number and gas request number to service
  passGrid() {
    const projectDetails: ProjectDetails = {
      stateCd: this.stateCd,
      projectNumber: this.projectNumber,
      projectName: this.projectName,
      grStatus: this.grStatus,
      bgrStatus: this.bgrStatus,
      requestTypeCd: this.requestTypeCd,
      isServiceRequested: this.isServiceRequested
    };
    this.session.GetGrid(projectDetails);
  }

  // code to pass grid data fetched from DB to service
  passBcaData() {
    this.session.GetBcaData(this.bcaData);
  }
  // code to pass search filters to service
  passSearchfilters() {
    this.session.GetSearchFilter(this.bcaSearch);
    this.session.GetSearchInsideFilter(this.searchForm.value);
  }

  // code for kendogrid template editing
  createNewProduct(): Product {
    return new Product();
  }

  // code to pass project data
  passProjectData() {
    this.session.GetShowActiveProjects(this.showOnlyActive);
    this.session.GetProjectList(this.projectList);
    if (this.showOnlyActive) {
      this.session.GetProjectData(this.projectList);
    } else {
      this.session.GetProjectData(this.filterProjectInside);
    }
  }

  // on submit
  submitForm() {
    const flag = this.validateFormNotEmpty();
    if (flag === false) {
      if (this.requestSearchForm.valid) {
        this.showOnlyActive = false;

        this.resetInternalSearchForm();

        // filtering part
        const { requestId, subsidaryCompany, projectName, projectAddress, startDate, endDate, bcaStatus } = this.requestSearchForm.value;

        this.filterProjects = this.projectList.filter((project) => {
          const filterRequestId = requestId ? ((project.gasRequestId == requestId) || (project.bcaId == requestId)) : true;
          const filterStartDate = startDate ? new Date(project.createDate) >= new Date(startDate) : true;
          const filterEndDate = endDate ? new Date(project.createDate) <= new Date(endDate) : true;
          const filterProjectAddress = projectAddress ? (project.serviceFormattedAddress||'').toLowerCase().includes(projectAddress.toLowerCase()) : true;
          const filterProjectName = projectName ? project.projectName.toLowerCase().includes(projectName.toLowerCase()) : true;
          const filterBcaStatus = bcaStatus ? project.bgrStatus.toString().toLowerCase() == bcaStatus['id'].toString().toLowerCase() : true;

          return (filterRequestId && filterStartDate && filterEndDate && filterProjectAddress && filterProjectName && filterBcaStatus)
        });

        this.filterProjectInside = this.filterProjects;

        this.filterProjectLength = this.filterProjects.length;

        // code to capture search form values into search input modal
        this.error = { isError: false, errorMessage: '', stDateError: false };

        this.bcaSearch.reqId = ((this.requestSearchForm.controls['requestId'].value !== null) &&
          this.requestSearchForm.controls['requestId'].value !== '') ?
          Number(this.requestSearchForm.controls['requestId'].value) : null;

        this.bcaSearch.projectName = (this.requestSearchForm.controls['projectName'].value !== null) ?
          this.requestSearchForm.controls['projectName'].value : null;

        this.bcaSearch.projectAddress = (this.requestSearchForm.controls['projectAddress'].value !== null) ?
          this.requestSearchForm.controls['projectAddress'].value : null;

        this.bcaSearch.bcaStatus = (this.requestSearchForm.controls['bcaStatus'].value !== null) ?
          this.requestSearchForm.controls['bcaStatus'].value.id : null;

        this.bcaSearch.bcaStatusValue = (this.requestSearchForm.controls['bcaStatus'].value !== null) ?
          this.requestSearchForm.controls['bcaStatus'].value : null;

        (this.requestSearchForm.controls['endDate'].value !== null && this.requestSearchForm.controls['endDate'].value !== '') ? (
          (this.requestSearchForm.controls['startDate'].value === null || this.requestSearchForm.controls['startDate'].value === '') ?
            this.error = { isError: true, errorMessage: 'Please enter start date!', stDateError: true } : this.ValidateDate()
        ) : (
          (this.requestSearchForm.controls['startDate'].value !== null && this.requestSearchForm.controls['startDate'].value !== '') ?
            this.error = { isError: true, errorMessage: 'Please enter end date!', stDateError: false } : null
        );
        if (this.error.isError === false) {
          this.bcaSearch.startDate = this.requestSearchForm.controls['startDate'].value;
          this.bcaSearch.endDate = this.requestSearchForm.controls['endDate'].value;
        }
        if (this.requestSearchForm.controls['subsidaryCompany'].value !== null) {
          this.bcaSearch.subsidarycompanyName = this.requestSearchForm.controls['subsidaryCompany'].value;
          for (let i = 0; i < this.builderInfo.BuilderMapping.length; i++) {
            if (this.bcaSearch.subsidarycompanyName.itemName === this.builderInfo.BuilderMapping[i].subsidiaryName) {
              this.bcaSearch.subsidaryId = this.builderInfo.BuilderMapping[i].subsidiaryId;
            }
          }
        } else {
          this.bcaSearch.subsidarycompanyName = null;
          this.bcaSearch.subsidaryId = null;
        }
        if (this.error.isError === false) {
          // -CXCO 751 :-28/05/2024 existing service tracker removed --Srinivas
          // this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
          this.bcaGrid();
        }
      } else {
        triggerFormValidation(this.requestSearchForm);
        focusFirstInvalidField(this.requestSearchForm);
      }
    } else {
      this.filterProjects = [];
      this.filterProjectLength = this.filterProjects.length;
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.searchCriteria, this.constantsSvc.errorSwal);
      }

      this.activeProjects = [];
      this.checkExport();
  }

  validateFormNotEmpty() {
    let flag = true; // form is empty
    Object.keys(this.requestSearchForm.controls).forEach(key => {
      if (this.requestSearchForm.controls[key].value !== null && this.requestSearchForm.controls[key].value !== '') {
        flag = false; // form is not empty
      }
    });
    if (this.searchAddress === null || this.searchAddress === '') {
      this.requestSearchForm.controls['projectAddress'].patchValue(this.searchAddress);
    } else {
      this.requestSearchForm.controls['projectAddress'].patchValue(this.searchAddress);
      flag = false; // address is not empty
    }
    return flag;

  }

  reset() {
    // code to resetsearch form on clicking of reset button
    this.searchAddress = null;
    this.requestSearchForm.patchValue({
      requestId: null,
      projectName: null,
      projectAddress: null,
      subsidaryCompany: null,
      bcaStatus: null,
      startDate: null,
      endDate: null
    });
    if (this.comp !== undefined) {
      this.comp.searchElementRef.nativeElement.value = '';
    }
    this.error = { isError: false, errorMessage: '', stDateError: false };
    this.strterror = { isError: false, errorMessage: '' };
    this.resetBCASearch();
    this.passSearchfilters();
    // code to reset the grid and fetch all data without any search filters
    //  -CXCO 751 :-28/05/2024 Existing tracker removed --srinivas

    // this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.bcaGrid();
  }

  // code to reset local search input modal
  resetBCASearch() {
    this.bcaSearch.builderId = this.builderInfo.BuilderId;
    this.bcaSearch.projectName = null;
    this.bcaSearch.projectAddress = null;
    this.bcaSearch.bcaStatus = null;
    this.bcaSearch.subsidaryId = null;
    this.bcaSearch.subsidarycompanyName = null;
    this.bcaSearch.startDate = null;
    this.bcaSearch.endDate = null;
    this.bcaSearch.reqId = null;
    this.bcaSearch.bcaStatusValue = null;
    this.requestSearchForm.reset();
    this.requestSearchForm.updateValueAndValidity();
    this.searchAddress = null;
    // uncommenting this bcaGrid unnecessary call
    this.showOnlyActive = true;
    this.bcaGrid();
  }
  // validate builder id
  ValidateBuilderId(dataitem) {
    for (let i = 0; i < this.bcaSearch.builderId.length; i++) {
      if (this.bcaSearch.builderId[i] === dataitem.builderId) {
        if ((dataitem.oldbgrStatus === this.constantsSvc.PENDCONTR) ||
          (dataitem.oldbgrStatus === this.constantsSvc.PENDPMNT) ||
          (dataitem.oldbgrStatus === this.constantsSvc.PENDPRMT) ||
          (dataitem.oldbgrStatus === this.constantsSvc.PENDINST) ||
          (dataitem.oldbgrStatus === this.constantsSvc.COMP)) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  // code to validate date search and show appropriate error
  ValidateDate() {
    if (new Date(this.requestSearchForm.controls['endDate'].value) < new Date(this.requestSearchForm.controls['startDate'].value)) {
      this.error = { isError: true, errorMessage: 'End Date can\'t be less than start date!' };
    } else {
      this.error = { isError: false, errorMessage: '' };
    }
  }

  navigateToTrackerpage(bcaId: number, gasRequestId: number) {
    let selectedProject = this.projectList.filter(proj => proj.gasRequestId === gasRequestId);

    if (selectedProject[0].projectCancelYN === 'Y') {
      this.showCancelledPopup();
      return;
    }
    else if (selectedProject[0].projectIsActiveYN === '30 DAYS EXCEEDED') {
      this.showProjectCompleteAlert();
      return;
    }
    else if ((selectedProject[0].projectCompletion !== 'C') && (selectedProject[0].bgrStatus !== "APPDENIED")) {
      this.showApplicationNotReceivedPopup();
      return;
    }
    else if ((selectedProject[0].denialReasonDesc !== null) && (selectedProject[0].denialReasonDesc !== '') && (selectedProject[0].bgrStatus === "APPDENIED")) {
      this.showApplicationDeniedPopup();
      return;
    }

    this.landingSvc.getBcaStatusById(bcaId).subscribe(result => {
      localStorage.setItem('serviceTrackerData', JSON.stringify(result.data));
      //navigating to tracker page
      this.session.GetShowBuilderHeader(true);
      this.router.navigate(['/', this.session.paramLdc.toLocaleLowerCase(), 'serviceTracker'], { queryParams: { fromBuilder: true } });
    });
  }

  navigateToServicepage(gasRequestId: number) {
    let selectedProject = this.projectList.filter(proj => proj.gasRequestId === gasRequestId);

    if (selectedProject[0].projectCancelYN === 'Y') {
      this.showCancelledPopup();
      return;
    }
    else if (selectedProject[0].projectIsActiveYN === '30 DAYS EXCEEDED') {
      this.showProjectCompleteAlert();
      return;
    }
    else if ((selectedProject[0].projectCompletion != 'C') && (selectedProject[0].bgrStatus !== "APPDENIED")) {
      this.showApplicationNotReceivedPopup();
      return;
    }
    else if ((selectedProject[0].denialReasonDesc !== null) && (selectedProject[0].denialReasonDesc !== '') && (selectedProject[0].bgrStatus === "APPDENIED")) {
      this.showApplicationDeniedPopup();
      return;
    }
    //navigating to service page
    this.router.navigate(['/ga/builder/request', gasRequestId, 'service']);
  }

  showCancelledPopup() {
    Swal.fire({
      title: 'Project is Cancelled',
      icon: 'error',
      confirmButtonText: 'OK',
      timer: 20000,
    });
  }

  showProjectCompleteAlert() {
    Swal.fire({
      title: 'Completed Projects > 30 Days will not display results.',
      icon: 'info',
      confirmButtonText: 'OK',
      timer: 20000,
    });
  }

  showApplicationNotReceivedPopup() {
    Swal.fire({
      icon: 'info',
      title: 'Application Pending. Please check back',
      confirmButtonText: 'OK'
    });
  }

  showApplicationDeniedPopup() {
    Swal.fire({
      icon: 'info',
      title: 'Application Denied', // Removing "Please check back" for defect fix - https://so-to.atlassian.net/browse/CXCO-1799.
      confirmButtonText: 'OK'
    })
  }

  //get holiday list data
  getHolidayList() {
    this.landingSvc.getHolidayList().subscribe(result => {
      localStorage.setItem('holidaysData', JSON.stringify(result.data))
    });
  }

  filterProjectsInternally(values: { builderId: string, projectNo: string, projectAddress: string }) {
    if (this.showOnlyActive) {
      this.activeProjects = this.projectList.filter(project => {
        const activeProjectsFilter = project.bgrStatus == 'ACTPRJ';
        const builderIdFilter = (!values.builderId || project.gasRequestId.toString().includes(values.builderId.toString()));
        const projectNumberFilter = (!values.projectNo || (project.bcaId ? project.bcaId.toString().includes(values.projectNo.toString()) : false));
        const projectAddressFilter = (!values.projectAddress || (project.serviceFormattedAddress||'')!.toLowerCase().includes(values.projectAddress.toLowerCase()));
        return (activeProjectsFilter && builderIdFilter && projectNumberFilter && projectAddressFilter);
      });
      this.activeProjectLength = this.activeProjects.length;
    }
    else {
      this.filterProjects = this.filterProjectInside.filter(project => {
        const builderIdFilter = (!values.builderId || project.gasRequestId.toString().includes(values.builderId.toString()));
        const projectNumberFilter = (!values.projectNo || (project.bcaId ? project.bcaId.toString().includes(values.projectNo.toString()) : false));
        const projectAddressFilter = (!values.projectAddress || (project.serviceFormattedAddress||'')!.toLowerCase().includes(values.projectAddress.toLowerCase()));
        return (builderIdFilter && projectNumberFilter && projectAddressFilter);
      });
      this.filterProjectLength = this.filterProjects.length;
    }
  }

  resetInternalSearchForm() {
    this.searchForm.patchValue({
      builderId: '',
      projectNo: '',
      projectAddress: ''
    });
    }


    // Method to export table data to Excel
    exportToExcel(): void {
        const selectedData = this.showOnlyActive ? this.activeProjects : this.filterProjects;

        // Prepare the data by selecting only the necessary columns
        const dataToExport = selectedData.map(project => ({
            gasRequestId: project.gasRequestId,
            bcaId: project.bcaId,
            serviceFormattedAddress: project.serviceFormattedAddress
        }));

        // Create the worksheet with the data
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

        // Now, let's define custom headers using the `header` property of the worksheet
        const customHeaders = {
            gasRequestId: 'Request Number',
            bcaId: 'Project Number',
            serviceFormattedAddress: 'Project Address'
        };

        // Rename the columns using the custom headers
        const range = XLSX.utils.decode_range(ws['!ref']);
        const headers = Object.values(customHeaders);

        // Set custom headers in the first row
        for (let i = 0; i < headers.length; i++) {
            ws[XLSX.utils.encode_cell({ r: 0, c: i })] = { v: headers[i], t: 's' };
        }

        // Create a new workbook and append the worksheet
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Projects');

        // Save the file with a specific name
        XLSX.writeFile(wb, 'projects.xlsx');
    }

    // Method to export table data to PDF
    exportToPDF(): void {
        const selectedData = this.showOnlyActive ? this.activeProjects : this.filterProjects;

        // Prepare the data by selecting only the necessary columns
        const dataToExport = selectedData.map(project => [
            project.gasRequestId,
            project.bcaId,
            project.serviceFormattedAddress
        ]);

        // Create a new jsPDF instance
        const doc = new jsPDF();

        // Set the title for the PDF (optional)
        doc.setFontSize(18);
        doc.text('Projects Table', 14, 16);

        // Set the column headers
        const headers = ['Request Number', 'Project Number', 'Project Address'];

        // Add the table to the PDF using autoTable
        autoTable(doc, {
            head: [headers],
            body: dataToExport,
            startY: 30, // Start the table below the title
            margin: { top: 20 },
        });

        // Save the PDF file with a specific name
        doc.save('projects_table.pdf');
    }
}
